/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useSnapshot } from "valtio";
import { store } from "../../../../components/VerticalLayout/store";
import { store as storeSaleSupport } from "../store";
import { removeArrayOfObjectsDuplicates } from "@helpers/general";
import { useCallbackPrompt } from "@hooks/useCallbackPrompt";
import { useTranslation } from "react-i18next";
import {
    setFranchiseDataIsUpdated,
    setSelectedSaleSupports,
    setSaleSupportData,
    setNumberActive,
    setNumberArchived,
    setListFranchiseArchived,
    setArchivedData,
    setActions,
    setValidationAction,
    setIsActionsClicked,
} from "../store";

export const useSaleSupportFranchiseLogic = (
    isArchivedSaleSupportClicked: boolean
) => {
    const { t } = useTranslation();
    const { oneShop, userID, franchiseID, shopID, operatorID } = useSnapshot(
        store
    );
    const { franchiseDataIsUpdated, isEdited } = useSnapshot(storeSaleSupport);
    const didMountRef = useRef(false);

    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
        isEdited
    );
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [data, setData] = useState<any>({});
    const [saleSupport, setSaleSupport] = useState<any>({});
    const [filterActive, setLocalFilterActive] = useState(false);
    const [isAddSaleSupportClicked, setIsAddSaleSupportClicked] = useState(
        false
    );
    const [isConsult, setIsConsult] = useState<boolean>(false);
    const [rowData, setRowData] = useState<any>({});
    const [dataState, setDataState] = useState<any>({});
    const [
        isAddNewSaleSupportButtonClicked,
        setIsAddNewSaleSupportButtonClicked,
    ] = useState(false);
    const [isModalConfirmationOpened, setIsModalConfirmationOpened] = useState<
        boolean
    >(false);
    const [isFavoriteModified, setIsFavoriteModified] = useState<boolean>(
        false
    );
    const [
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
    ] = useState<boolean>(false);

    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");
    const shopId = oneShop ? shopID : "0";

    const urlBase = `${process.env.REACT_APP_API_V2_URL}/settings/general/saleSupport`;
    const url = `${urlBase}?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&type=${
        isArchivedSaleSupportClicked ? "archived" : "activated"
    }`;

    useEffect(() => {
        if (filterActive) {
            setIsAddSaleSupportClicked(false);
        }
        setIsAddSaleSupportClicked(false);
        setSaleSupport([]);
        if (didMountRef.current) {
            setFranchiseDataIsUpdated(true);
        } else {
            didMountRef.current = true;
        }
    }, []);

    useEffect(() => {
        if (data?.othersData) {
            const others = data.othersData;
            setSaleSupportData(data.data ?? []);
            setNumberActive(others.activated ?? 0);
            setNumberArchived(others.archived ?? 0);
            setListFranchiseArchived(others.dataArchive?.data ?? []);
            setArchivedData(others.archivedData?.data ?? []);
        } else {
            setSaleSupportData([]);
            setNumberActive(0);
            setNumberArchived(0);
            setListFranchiseArchived([]);
            setArchivedData([]);
        }
    }, [data, isArchivedSaleSupportClicked]);

    useEffect(() => {
        if (!selectedRows.length) {
            setSelectedSaleSupports([]);
            return;
        }
        const supports = selectedRows.flatMap((row: any) =>
            row[t("Shop")]
                ? row.subRows.map((el: any) => ({ [el.shopId]: el.Id }))
                : [{ [row.shopId]: row.Id }]
        );
        setSelectedSaleSupports(removeArrayOfObjectsDuplicates(supports));
    }, [selectedRows, t]);

    useEffect(() => {
        setActions(confirmNavigation);
        setIsActionsClicked(Boolean(showPrompt));
        setValidationAction(cancelNavigation);
    }, [showPrompt, confirmNavigation, cancelNavigation]);

    return {
        url,
        userData: {
            userId: userID,
            shopId,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser,
        },
        i18nextLng,
        oneShop,
        data,
        setData,
        saleSupport,
        setSaleSupport,
        filterActive,
        setLocalFilterActive,
        isAddSaleSupportClicked,
        setIsAddSaleSupportClicked,
        selectedRows,
        setSelectedRows,
        franchiseDataIsUpdated,
        isConsult,
        setIsConsult,
        dataState,
        rowData,
        setRowData,
        setDataState,
        isAddNewSaleSupportButtonClicked,
        setIsAddNewSaleSupportButtonClicked,
        isModalConfirmationOpened,
        setIsModalConfirmationOpened,
        isFavoriteModified,
        setIsFavoriteModified,
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
    };
};
